// 环境类型标签
export enum GameEnvType {
  Dev = 'DEV', // 测试环境
  Live = 'LIVE', // 正式环境
}

// 环境部署地区
export enum GameEnvRegion {
  'European(Frankfurt)' = '1',
  'Asian(Singapore)' = '2',
  'North America(Virginia)' = '3',
  'East China(Shanghai)' = '4',
  'Woa' = '5',
  'DevCloud' = '6',
}

// 获取环境
export interface IGameEnvModel {
  readonly id: number; // envID
  readonly GameID: string;
  readonly Name: string;
  readonly Type: GameEnvType;
  readonly Region: GameEnvRegion;
  readonly FounderID: number;
  readonly ApiEndpoint: string;
  readonly CreateTime: Date;
  readonly ModifyTime: Date;
  readonly FounderUid: string;

  // G6特殊要求规范，遵循k8s命名规范 {game_id}-{region}-{env_name}-{env_type}
  readonly Guid: string;
  readonly GosParams?: string;
  readonly BianqueParams?: string;
  readonly Description?: string;
}

export interface IApiGameEnvCollectionRes {
  readonly gameName: string;
  readonly gameID: string;
  readonly gamekey: string;
  readonly gameColor: string | null;
  readonly gameCreatorID: string;
  readonly gameStudioID: string | null;
  readonly gameSource: number;
  readonly gameCreateTime: string;
  readonly envIncrementID: number;
  readonly envName: string;
  readonly envType: GameEnvType;
  readonly envRegion: GameEnvRegion;
  readonly envFounderID: number | null;
  readonly envCreateTime: string;
  readonly envGuid: string;
  readonly envGosParams: string | null;
}

// 创建环境
export interface IGameEnvCreate {
  readonly StudioID: string; // 工作室id
  readonly GameID: string; // 游戏id
  readonly Name: string; // 环境名称（英文）
  readonly Type: GameEnvType; // 环境类型
  readonly Region: GameEnvRegion; // 区域
  readonly ApiEndpoint: string; // API地址
  readonly ServiceIds?: Array<number>; // 快捷开通的服务, 传服务id. 不选择则传空---获取无
  readonly CreateTime?: Date;
  readonly ModifyTime?: Date;
  readonly Description?: string;
}
// 同步环境
export interface IGameEnvSync {
  readonly gameID: String;
  readonly sourceEnvID: Number;
  readonly targetEnvID: Number;
  // readonly ServiceIds: Array<Number>;
  force?: Number;
  readonly transparentData?: Record<string, any>;
}

// 删除环境参数
export interface IGameEnvDelete {
  readonly gameID: string;
  readonly gameName: string;
  readonly studioID: string;
  readonly studioName: string;
  readonly regionName: string;
  readonly envName: string;
  readonly envType: GameEnvType;
  readonly serviceNames: ReadonlyArray<string>;
}

// 删除环境参数
// 运维部署通知
export interface IEnvService {
  readonly gameID: string;
  readonly gameName: string;
  readonly studioID: string;
  readonly studioName: string;
  readonly regionName: string;
  readonly envs: ReadonlyArray<{
    readonly envName: string;
    readonly envType: GameEnvType;
    readonly serviceNames: ReadonlyArray<string>;
    readonly region?: GameEnvRegion;
    readonly envID?: string;
  }>;
}

export interface ISyncServiceConfig {
  readonly uniqueNames: string[];
  readonly domainApi: string;
}

export interface IServiceBatchApproval {
  readonly recordIds: Number[];
  readonly status: Number;
  readonly expectedAmount: number;
  readonly envType: string;
  readonly rejectReason?: string;
  readonly projectCode?: string;
  readonly chartVersion?: string;
  readonly enableBianque?: boolean;
  readonly enableAccess?: boolean;
  readonly reportGateway?: boolean;
  readonly g6DomainURL?: string;
  gauthServiceType?: string;
  gauthServiceTypeNme?: string;
}

export interface IServiceBatchApprovalParams {
  readonly recordIds: Number[];
  readonly status: Number;
  readonly expectedAmount: number;
  readonly envType: string;
  readonly rejectReason?: string;
  readonly projectCode?: string;
  readonly chartVersion?: string;
  readonly enableBianque?: boolean;
  readonly enableAccess?: boolean;
  readonly reportGateway?: boolean;
  readonly g6DomainURL?: string;
  readonly isNoDeployEnabled?: boolean;
}

export enum TaskDrawerType {
  ViewPlan = 'view plan',
  OpenType = 'open type',
  Open = 'open',
  Close = 'close',
}

export interface IEnvExportParams {
  readonly services: string[];
  readonly game_id: number;
  readonly env_id: string;
  readonly gameID: string;
  readonly envID: string;
}

export interface IEnvImportCheckParams {
  readonly game_id: number;
  readonly env_id: string;
  readonly package_fs_id: string;
  readonly gameID: string;
  readonly envID: string;
}

export interface IEnvImportCheck {
  readonly code: number;
  readonly msg_en: string;
  readonly result: Record<string, any>;
  readonly request_id: string;
  readonly msg: string;
  readonly total: number;
  readonly api_version: string;
}

export interface IUpdateEnvBody {
  readonly name?: string;
  readonly Description?: string;
}

export interface IFrequencyDefinition {
  readonly weekDefinition: Record<string, any>;
  readonly monthDefinition: Record<string, any>;
  readonly dayDefinition: Record<string, any>;
  readonly timeZone: string;
  readonly timeOffset: number;
}

export interface ITimeSettingBody {
  readonly game_id: string;
  readonly env_id: string;
  readonly gameID: string;
  readonly envID: number;
  readonly frequency_definition: IFrequencyDefinition;
}
